(function () {
  var RESULTS_LIMIT = 5;
  var DEBOUNCE_MS = 100;

  function buildSuggestUrl(query) {
    return '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=' + RESULTS_LIMIT +
      '&resources[options][unavailable_products]=last';
  }

  function renderItemsInto(container, products) {
    container.innerHTML = '';

    if (!products.length) {
      container.hidden = true;
      return;
    }

    products.forEach(function (product) {
      var link = document.createElement('a');
      link.className = 'bc-predictive-search__item';
      link.href = product.url;

      var img = document.createElement('img');
      img.className = 'bc-predictive-search__image';
      img.alt = '';
      img.loading = 'lazy';
      if (product.image) {
        img.src = product.image + (product.image.indexOf('?') > -1 ? '&' : '?') + 'width=100';
      }

      var info = document.createElement('span');
      info.className = 'bc-predictive-search__info';

      var title = document.createElement('span');
      title.className = 'bc-predictive-search__title';
      title.textContent = product.title;

      info.appendChild(title);
      link.appendChild(img);
      link.appendChild(info);
      container.appendChild(link);
    });

    container.hidden = false;
  }

  /* Header search icon + dropdown panel */
  (function () {
    var toggle = document.getElementById('BcSearchToggle');
    if (!toggle) return;

    var panel = document.createElement('div');
    panel.className = 'bc-predictive-search__panel';
    panel.id = 'BcSearchPanel';
    panel.hidden = true;

    var form = document.createElement('form');
    form.className = 'bc-predictive-search__form';
    form.action = '/search';
    form.method = 'get';
    form.setAttribute('role', 'search');

    var input = document.createElement('input');
    input.type = 'search';
    input.name = 'q';
    input.className = 'bc-predictive-search__input rps_ignore_search_input';
    input.id = 'BcSearchInput';
    input.placeholder = toggle.getAttribute('aria-label') || 'Search';
    input.setAttribute('autocomplete', 'off');

    form.appendChild(input);

    var results = document.createElement('div');
    results.className = 'bc-predictive-search__results';
    results.id = 'BcSearchResults';
    results.hidden = true;

    panel.appendChild(form);
    panel.appendChild(results);
    var headerEl = toggle.closest('.site-header');
    (headerEl || document.body).appendChild(panel);

    var debounceTimer = null;
    var latestRequestId = 0;
    var currentController = null;

    function getPageContentBox() {
      var pw = document.querySelector('.page-width');
      if (!pw) return null;
      var rect = pw.getBoundingClientRect();
      var cs = getComputedStyle(pw);
      var padLeft = parseFloat(cs.paddingLeft) || 0;
      var padRight = parseFloat(cs.paddingRight) || 0;
      return {
        left: rect.left + padLeft,
        right: rect.right - padRight,
        width: rect.width - padLeft - padRight
      };
    }

    function positionPanel() {
      if (window.innerWidth <= 749) {
        panel.style.top = '';
        panel.style.left = '';
        panel.style.width = '';
        return;
      }

      var rect = toggle.getBoundingClientRect();
      var box = getPageContentBox();
      var width;

      if (box) {
        width = box.width * 0.4;
      } else {
        width = Math.max(rect.width, 280);
      }

      var left = rect.right - width;
      if (box && left < box.left) left = box.left;
      if (left < 8) left = 8;

      panel.style.top = (rect.bottom + 8) + 'px';
      panel.style.left = left + 'px';
      panel.style.width = width + 'px';
    }

    function clearResults() {
      results.innerHTML = '';
      results.hidden = true;
    }

    function showLoading() {
      results.innerHTML = '<div class="bc-predictive-search__loading">Searching…</div>';
      results.hidden = false;
      positionPanel();
    }

    function openPanel() {
      positionPanel();
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      input.focus();

      var query = input.value.trim();
      if (query.length >= 2) {
        showLoading();
        fetchResults(query);
      }
    }

    function closePanel() {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      clearResults();
    }

    function fetchResults(query) {
      var requestId = ++latestRequestId;

      if (currentController) currentController.abort();
      currentController = new AbortController();

      fetch(buildSuggestUrl(query), { signal: currentController.signal })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (requestId !== latestRequestId) return;
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderItemsInto(results, products);
          positionPanel();
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          if (requestId === latestRequestId) clearResults();
        });
    }

    function getMobileNavToggle() {
      return document.querySelector('.js-mobile-nav-toggle');
    }

    function getMobileNavWrapper() {
      return document.querySelector('.mobile-nav-wrapper');
    }

    function withoutTransitions(fn) {
      var html = document.documentElement;
      html.classList.add('bc-no-transition');
      void html.offsetHeight;
      fn();
      void html.offsetHeight;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          html.classList.remove('bc-no-transition');
        });
      });
    }

    function closeMobileNavInstantly() {
      var navToggle = getMobileNavToggle();
      var navWrapper = getMobileNavWrapper();
      if (!navToggle || !navWrapper || !navWrapper.classList.contains('js-menu--is-open')) return;
      withoutTransitions(function () {
        navToggle.click();
      });
    }

    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (panel.hidden) {
        closeMobileNavInstantly();
        openPanel();
      } else {
        closePanel();
      }
    });

    document.addEventListener('click', function (event) {
      var navToggle = getMobileNavToggle();
      if (!navToggle) return;
      if (event.target !== navToggle && !navToggle.contains(event.target)) return;
      if (!panel.hidden) closePanel();
    }, true);

    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearTimeout(debounceTimer);

      if (query.length < 2) {
        if (currentController) currentController.abort();
        latestRequestId++;
        clearResults();
        return;
      }

      debounceTimer = setTimeout(function () {
        showLoading();
        fetchResults(query);
      }, DEBOUNCE_MS);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !panel.hidden) {
        closePanel();
      }
    });

    document.addEventListener('click', function (event) {
      if (panel.hidden) return;
      if (panel.contains(event.target) || toggle.contains(event.target)) return;
      closePanel();
    });

    window.addEventListener('resize', function () {
      if (!panel.hidden) positionPanel();
    });

    window.addEventListener('scroll', function () {
      if (panel.hidden) return;
      if (window.innerWidth <= 749) return;
      positionPanel();
    }, true);
  })();

  /* Search results page: dropdown under the middle search box */
  (function () {
    var input = document.getElementById('SearchInput');
    var submit = document.getElementById('SearchResultSubmit');
    if (!input || !submit) return;

    var results = document.createElement('div');
    results.className = 'bc-predictive-search__results bc-predictive-search__results--inline';
    results.id = 'SearchInputResults';
    results.hidden = true;

    var group = input.closest('.input-group') || input.parentNode;
    var container = group.parentNode;
    if (getComputedStyle(container).position === 'static') {
      container.style.position = 'relative';
    }
    container.insertBefore(results, group.nextSibling);

    var debounceTimer = null;
    var latestRequestId = 0;
    var currentController = null;

    function clearResults() {
      results.innerHTML = '';
      results.hidden = true;
    }

    function showLoading() {
      results.innerHTML = '<div class="bc-predictive-search__loading">Searching…</div>';
      results.hidden = false;
    }

    function fetchResults(query) {
      var requestId = ++latestRequestId;

      if (currentController) currentController.abort();
      currentController = new AbortController();

      fetch(buildSuggestUrl(query), { signal: currentController.signal })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (requestId !== latestRequestId) return;
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderItemsInto(results, products);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          if (requestId === latestRequestId) clearResults();
        });
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearTimeout(debounceTimer);

      if (query.length < 2) {
        if (currentController) currentController.abort();
        latestRequestId++;
        clearResults();
        return;
      }

      debounceTimer = setTimeout(function () {
        showLoading();
        fetchResults(query);
      }, DEBOUNCE_MS);
    });

    input.addEventListener('focus', function () {
      var query = input.value.trim();
      if (query.length >= 2 && results.hidden) {
        showLoading();
        fetchResults(query);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !results.hidden) {
        clearResults();
      }
    });

    document.addEventListener('click', function (event) {
      if (results.hidden) return;
      if (results.contains(event.target) || input.contains(event.target)) return;
      clearResults();
    });
  })();
})();
